import { FiltroUnidade } from "../../../../services/home";

export const mascararDocumento = (documento: string) => {
  const digitos = (documento || "").replace(/\D/g, "");
  if (digitos.length === 14) {
    return digitos.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  }
  if (digitos.length === 11) {
    return digitos.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  }
  return documento;
};

export const rotuloDeUnidade = (unidade: FiltroUnidade) => {
  const apelido = (unidade.apelido || "").trim();
  if (apelido) {
    return apelido;
  }
  const documento = (unidade.documento || "").trim();
  return documento ? mascararDocumento(documento) : `Unidade ${unidade.codPessoa}`;
};

export const rotuloUnidadePorCodigo = (codPessoa: number | null | undefined, unidades: FiltroUnidade[]) => {
  if (codPessoa == null) {
    return "";
  }
  const unidade = unidades.find((u) => u.codPessoa === codPessoa);
  return unidade ? rotuloDeUnidade(unidade) : `Unidade ${codPessoa}`;
};
